/** A value as a list: empty for undefined, null or '', a copy for an array. */
export function toList(value: any): any[] {
  if (value === undefined || value === null || value === '') {
    return [];
  }
  return Array.isArray(value) ? value.slice() : [value];
}
